<template>
  <div class="loader">
    <Loader :height="'6vh'" />
  </div>
</template>

<script>
import Loader from './Loader.vue';

export default {
  name: 'LoadInScreen',
  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/_config.scss";

.loader {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: $stoneLight;
  background: radial-gradient(circle, rgba(253,250,245,1) 0%, rgba(223,222,213,1) 80%);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0;
}

</style>
